export default {
  //this is for LOCALHOST
  // host: true,

  //this is for LIVE SERVER
  host: false,
};
